import { useSelector } from 'react-redux';

import { makeGetCurrentUserId, makeGetCurrentUser, makeGetUsers, makeGetResolvedNonGuestTeamUsers } from 'selectors/users';

import { useCurrentTeam } from 'shared-hooks/team';

const getCurrentUserId = makeGetCurrentUserId();

export const useCurrentUserId = () => {
    const currentUserId = useSelector(({ users }) => getCurrentUserId(users));

    return currentUserId;
};

const getCurrentUser = makeGetCurrentUser();

export const useCurrentUser = () => {
    const currentUser = useSelector(({ users }) => getCurrentUser(users));

    return currentUser;
};

export const useCurrentUserRole = () => {
    const currentUser = useCurrentUser();

    return currentUser?.role;
};

const getUsers = makeGetUsers();

export const useResolvedUsers = userIds => {
    const users = useSelector(({ users }) => getUsers(users.items, userIds));

    return users;
}

const getResolvedNonGuestTeamUsers = makeGetResolvedNonGuestTeamUsers();

export const useNonGuestUsers = () => {
    const team = useCurrentTeam();

    const users = useSelector(({ users }) => getResolvedNonGuestTeamUsers(team, users));

    return {
        data: users,
        error: null,
        promise: Promise.resolve(),
        isLoading: false
    }
}
